import { z } from 'zod'

export const NameSchema = z.object({
  firstName: z.string().nullable().optional(),
  lastName: z.string().nullable().optional()
})

export const EmailSchema = z.object({
  email: z
    .string()
    .min(1, 'This field is required')
    .email('Invalid email address')
})

export const PhoneSchema = z.object({
  phoneNumber: z.string().nullable().optional()
})

const AddressSchema = z.object({
  address1: z.string().min(1, { message: 'Address 1 cannot be empty' }),
  address2: z.string().nullable().optional(),
  city: z.string().min(1, { message: 'City cannot be empty' }),
  zip: z.string().min(1, { message: 'Postal code cannot be empty' }),
  zoneCode: z.string().nullable().optional(),
  id: z.string(),
  firstName: z.string().min(1, { message: 'First Name cannot be empty' }),
  lastName: z.string().min(1, { message: 'Last Name cannot be empty' })
})

export const UserProfileAddressSchema = AddressSchema
